import {
    CategoryPageContainer as SourceCategoryPageContainer,
    mapStateToProps,
    mapDispatchToProps
} from 'SourceRoute/CategoryPage/CategoryPage.container';
import { connect } from 'react-redux';

import { getQueryParam, setQueryParams } from 'Util/Url';
import { debounce } from 'Util/Request';

import { LOADING_TIME } from './CategoryPage.config';


export class CategoryPageContainer extends SourceCategoryPageContainer {
    config = {
        sortKey: 'top_seller_alt',
        sortDirection: 'DESC'
    };

    // ! add meta robots (must be remove after scandipwa update)
    componentDidUpdate(prevProps) {
        const {
            isOffline,
            categoryIds,
            category: {
                id
            },
            currentArgs: {
                filter
            } = {}
        } = this.props;

        const {
            breadcrumbsWereUpdated
        } = this.state;

        const {
            categoryIds: prevCategoryIds,
            category: {
                id: prevId
            },
            currentArgs: {
                filter: prevFilter
            } = {}
        } = prevProps;

        // TODO: category scrolls up when coming from PDP

        if (isOffline) {
            debounce(this.setOfflineNoticeSize, LOADING_TIME)();
        }

        /**
         * If the URL rewrite has been changed, make sure the category ID
         * will persist in the history state.
         */
        if (categoryIds !== prevCategoryIds) {
            this.updateHistory();
        }

        /**
         * If the currently loaded category ID does not match the ID of
         * category from URL rewrite, request category.
         */
        if (categoryIds !== id) {
            this.requestCategory();
        }

        /**
         * If category ID was changed => it is loaded => we need to
         * update category specific information, i.e. breadcrumbs.
         *
         * Or if the breadcrumbs were not yet updated after category request,
         * and the category ID expected to load was loaded, update data.
         */
        const categoryChange = id !== prevId || (!breadcrumbsWereUpdated && id === categoryIds);
        if (categoryChange) {
            this.checkIsActive();
            this.updateMeta();
            this.updateBreadcrumbs();
            this.updateHeaderState();
        }

        /**
         * If category wasn't changed we still need to update meta for correct robots meta tag [#928](https://github.com/scandipwa/base-theme/issues/928)
         */
        if (!categoryChange
            && filter
            && prevFilter
            && Object.keys(filter.customFilters).length !== Object.keys(prevFilter.customFilters).length
        ) {
            this.updateMeta();
        }
    }

    getIsMatchingListFilter() { // remove this after update
        const {
            location,
            currentArgs: {
                currentPage,
                sort,
                filter
            } = {}
        } = this.props;

        /**
         * ? implementation bellow blinks, implementation with categoryIds check only does not show loading when selecting filters.
         * TODO: resolve it to be a combination of these two behaviour
         */

        // Data used to request category matches current data
        return JSON.stringify(filter) === JSON.stringify(this.getFilter())
            && JSON.stringify(sort) === JSON.stringify(this.getSelectedSortFromUrl())
            && currentPage === +(getQueryParam('page', location) || 1);
    }

    isCurrentCategoryLoaded() { // remove this after update
        const {
            categoryIds,
            category: {
                id
            },
            isSearchPage
        } = this.props;

        return isSearchPage || categoryIds === id;
    }

    containerProps = () => ({ // remove this after update
        filter: this.getFilter(),
        isCurrentCategoryLoaded: this.isCurrentCategoryLoaded(),
        isMatchingListFilter: this.getIsMatchingListFilter(),
        isMatchingInfoFilter: this.getIsMatchingInfoFilter(),
        selectedSort: this.getSelectedSortFromUrl(),
        selectedFilters: this.getSelectedFiltersFromUrl(),
        isContentFiltered: this.isContentFiltered()
    });

    onSortChange(sortDirection, sortKey) {
        const { location, history } = this.props;

        setQueryParams({ sortKey }, location, history);
        setQueryParams({ sortDirection }, location, history);
        this.updateMeta();
    }

    updateMeta() {
        const { updateMetaFromCategory, category, history } = this.props;
        const meta_robots = history.location.search
            ? 'noindex, follow'
            : null;

        updateMetaFromCategory({
            ...category,
            ...meta_robots && { meta_robots: meta_robots },
        });
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryPageContainer);
